import { logger, makeRequest } from '@crx-dev/hss-react-infrastructure';
import { Setting } from '../../Areas/Settings/types/Setting';

export async function fetchStoreSettings(): Promise<[] | Setting[]> {
    try {
        var result = await makeRequest({
            method: 'GET',
            path: '/api/v1/Settings/storeSettings'
        });

        return result as Setting[];
    } catch (e) {
        logger.log('Error', `Settings: ${e} `);
    }

    return [];
}
